<div class="payments-page">
  <div class="payments-card">
    <div class="card-heading">
      <span class="card-title">Accepted Payment Methods</span>
      <span class="card-subtitle">
        Turn on to allow the customer to use multiple payment methods. Set default behaviors and
        local currency options.
      </span>
    </div>

    <div class="method-list">
      @for (method of methods; track method.key) {
        <div class="method-row">
          <span class="method-icon"><i [class]="method.icon"></i></span>
          <div class="method-text">
            <span class="method-title">{{ method.title }}</span>
            <span class="method-desc">{{ method.description }}</span>
          </div>
          <label class="switch">
            <input
              type="checkbox"
              role="switch"
              [checked]="draft[method.key]"
              (change)="toggle(method.key, $event)"
              [attr.aria-label]="method.title"
            />
            <span class="slider"></span>
          </label>
        </div>
      }
    </div>

    <div class="card-actions">
      <button type="button" class="cancel-btn" [disabled]="!isDirty" (click)="cancel()">
        Cancel
      </button>
      <button type="button" class="save-btn" [disabled]="!isDirty" (click)="save()">
        Save Changes
      </button>
    </div>
  </div>
</div>
